import { Formik } from 'formik';
import { Button, Modal } from 'react-bootstrap';
import GenerateFormHTMLNoValid from '../../../../../../../../../../component/generate-form/GenerateFormHTMLNoValid';
import useFormIO from '../../../../../../../hooks/useFormIO';
import CustomComponent from './CustomComponent';
import { useContext, useEffect, useRef, useMemo } from 'react';
import { CODE, RESPONSE_MESSAGE } from '../../../../../../../../../../utils/Constant';
import { createPhieuDieuTri } from '../../../../../../../../../services/BenhAnServices';
import { toast } from 'react-toastify';
import { localStorageItem } from '../../../../../../../../../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from '../../../../../../../../../../auth/core/_consts';
import { AppContext } from '../../../../../../../../../../appContext/AppContext';
import { PhanHeDieuTriContext } from '../../../../../../../../../PhanHeDieuTriContext';
import { FORMIO_CODE } from '../../../../../../../constant';
import { generateInitValues, generateValidationSchema } from '../../../../../../../../../../utils/AppFunction';

type Props = {
	open: boolean;
	onClose: () => void;
	callbackFunc?: (data?: any) => void;
	benhNhanDieuTri?: any;
};

const PhieuDieuTriDialog = ({ open, onClose, callbackFunc, benhNhanDieuTri }: Props) => {
	const { generalForm: formJSON } = useFormIO({
		code: FORMIO_CODE.PHIEU_DIEU_TRI_DIALOG
	});
	const { setIsLoading } = useContext(AppContext);
	const { benhNhanDieuTri: benhNhanDieuTriContext } = useContext(PhanHeDieuTriContext);

	const formRef = useRef<any>(null);

	const userInfo = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);
	const initialValues = useMemo(() => ({
		phieuDieuTri: {
			...generateInitValues(formJSON),
			doctorName: userInfo?.name,
		},
		isDialog: true
	}), [formJSON]);
	
	useEffect(() => {
		formRef.current?.setValues(initialValues);
	}, [initialValues]);
	const patientInfo = benhNhanDieuTri || benhNhanDieuTriContext;

	const handleSubmit = async (values: any) => {
		try {
			setIsLoading(true);
			let submitData = {
				...values?.phieuDieuTri,
				treatmentId: patientInfo?.treatmentId,
				patientId: patientInfo?.patientId,
				visitId: patientInfo?.visitId,
				medicalRecordCode: patientInfo?.medicalRecordCode,
				termModelCode: FORMIO_CODE.PHIEU_DIEU_TRI_DIALOG,
				diagnosisCoded: values?.provisionalDiagnosis,
				diagnosisCodedName: values?.provisionalDiagnosisName,
				diagnosisNonCoded: values?.diagnosisNonCoded,
				comorbidity: values?.comorbidity,
			};
			let { data } = await createPhieuDieuTri(submitData);
			if (data?.code === CODE.SUCCESS) {
				callbackFunc?.(data?.data);
				onClose();
				toast.success("Thành công");
			} else {
				toast.warning(RESPONSE_MESSAGE.ERROR);
			}
		} catch {
			console.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Modal
			dialogClassName="h-modal modal-90w"
			size="xl"
			show={open}
			centered
			onHide={onClose}
			scrollable
		>
			<Modal.Header closeButton>
				<Modal.Title>Thêm phiếu điều trị</Modal.Title>
			</Modal.Header>

			<Formik
				initialValues={initialValues}
				validationSchema={generateValidationSchema(formJSON, "phieuDieuTri")}
				onSubmit={handleSubmit}
				innerRef={formRef}
			>
				{({ values, setFieldValue, submitForm, errors, touched }) => (
					<div className='flex-column overflow-hidden'>
						<Modal.Body className='spaces min-h-500'>
							<GenerateFormHTMLNoValid
								isView={false}
								listFieldAuto={formJSON}
								values={values}
								setFieldValue={setFieldValue}
								errors={errors}
								touched={touched}
								modelID="phieuDieuTri"
								customComponent={CustomComponent}
							/>
						</Modal.Body>
						<Modal.Footer>
							<div className="d-flex justify-content-end">
								<Button className="btn-fill" onClick={submitForm}>
									<i className="bi bi-plus"></i>
									Lưu
								</Button>
							</div>
						</Modal.Footer>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default PhieuDieuTriDialog;
